import { render, staticRenderFns } from "./DeleteInventoryItemModal.vue?vue&type=template&id=63a0d3ba&scoped=true&class=fill-height&"
import script from "./DeleteInventoryItemModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteInventoryItemModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteInventoryItemModal.vue?vue&type=style&index=0&id=63a0d3ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0d3ba",
  null
  
)

export default component.exports